import { MEDIA_TYPES } from 'app/analytics/constants/media';

const contentMedia = ({
  id = '',
  name = '',
  mediaType = MEDIA_TYPES.SERIES,
} = {}) => ({ ContentMedia: { mediaId: id, mediaTitle: name, mediaType } });

export default contentMedia;
